import * as tslib_1 from "tslib";
var Input = (function () {
    function Input() {
    }
    Input.done = function () {
        return new StringInput('');
    };
    return Input;
}());
export { Input };
var StringInput = (function (_super) {
    tslib_1.__extends(StringInput, _super);
    function StringInput(buffer, index, more) {
        if (index === void 0) { index = 0; }
        if (more === void 0) { more = false; }
        var _this = _super.call(this) || this;
        _this.buffer = buffer;
        _this.index = index;
        _this.more = more;
        return _this;
    }
    StringInput.prototype.isDone = function () {
        return this.isEmpty() && !this.more;
    };
    StringInput.prototype.isEmpty = function () {
        return this.index >= this.buffer.length;
    };
    StringInput.prototype.head = function () {
        var c1 = this.buffer.charCodeAt(this.index);
        if (c1 <= 0xD7FF || c1 >= 0xE000) {
            return c1;
        }
        else if (c1 <= 0xDBFF && this.index + 1 < this.buffer.length) {
            var c2 = this.buffer.charCodeAt(this.index + 1);
            if (c2 >= 0xDC00 && c2 <= 0xDFFF) {
                return (((c1 & 0x3FF) << 10) | (c2 & 0x3FF)) + 0x10000;
            }
            else {
                return 0xFFFD;
            }
        }
        else {
            return 0xFFFD;
        }
    };
    StringInput.prototype.step = function () {
        var c1 = this.buffer.charCodeAt(this.index);
        if (c1 <= 0xD7FF || c1 >= 0xE000) {
            this.index += 1;
        }
        else if (c1 <= 0xDBFF && this.index + 1 < this.buffer.length) {
            var c2 = this.buffer.charCodeAt(this.index + 1);
            if (c2 >= 0xDC00 && c2 <= 0xDFFF) {
                this.index += 2;
            }
            else {
                this.index += 1;
            }
        }
        else {
            this.index += 1;
        }
    };
    StringInput.prototype.clone = function () {
        return new StringInput(this.buffer, this.index, this.more);
    };
    return StringInput;
}(Input));
export { StringInput };
//# sourceMappingURL=data:application/json;base64,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